import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AdminTokensListComponent } from '../../lists/admin-tokens-list/admin-tokens-list.component';

@Component({
  selector: 'app-admin-tokens',
  standalone: true,
  templateUrl: './admin-tokens.component.html',
  styleUrls: ['./admin-tokens.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AdminTokensListComponent],
})
export class AdminTokensComponent {}
